<app-onboarding-profile-shell>
  @if (isNameFromTruecaller()) {
    <div shellHeading
      class="tw-font-bold tw-leading-1.2 tw-text-gray-800"
      [class.tw-text-600]="isDravidianScriptUser()"
      [class.tw-text-700]="!isDravidianScriptUser()"
      i18n="@@confirmYourNameHeading">Confirm <br/> your name</div>
  } @else {
    <div shellHeading
      class="tw-font-bold tw-leading-1.2 tw-text-gray-800"
      [class.tw-text-600]="isDravidianScriptUser()"
      [class.tw-text-700]="!isDravidianScriptUser()"
      i18n="@@tellUsYourNameHeading">Tell us <br/> your name</div>
  }

  <div class="tw-relative">
    <input class="tw-m-0 tw-h-12 tw-w-full tw-rounded-2.5 tw-border tw-border-solid tw-bg-gray-100 tw-pl-3 tw-font-body tw-text-300 tw-text-gray-800 placeholder:tw-text-left placeholder:tw-text-300 placeholder:tw-font-normal placeholder:tw-text-gray-400"
      #nameInput
      id="nameInput"
      name="patientName"
      type="text"
      autocomplete="off"
      [class.tw-pr-10]="isNameFromTruecaller()"
      [class.tw-pr-3]="!isNameFromTruecaller()"
      [class.tw-border-gray-300]="(!isFilled() && !hasError()) || isNameFromTruecaller()"
      [class.tw-border-teal-400]="isValidAndFilled() && !isNameFromTruecaller()"
      [class.tw-border-orange-500]="hasError()"
      [ngModel]="patientName()"
      (ngModelChange)="onNameChange($event)"
      (paste)="onInputPaste($event)"
      placeholder="write your name here"
      i18n-placeholder="@@writeYourNameHere" />
    @if (isNameFromTruecaller()) {
      <button class="tw-absolute tw-right-1 tw-top-0 tw-m-0 tw-flex tw-h-12 tw-w-10 tw-min-w-unset tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0"
        id="clearPrefilledName"
        type="button"
        aria-label="Clear name"
        i18n-aria-label="@@clearPrefilledName"
        (click)="clearPrefilledName()">
        <em class="cs-icon-close tw-text-400 tw-text-gray-500"></em>
      </button>
    }
  </div>
  @if (isNameFromTruecaller()) {
    <p class="tw-mt-2 tw-flex tw-items-center tw-gap-1 tw-font-body tw-text-200 tw-text-gray-500"
      id="truecallerNameNote">
      <em class="cs-icon-info tw-shrink-0 tw-text-200"></em>
      <span class="tw-italic" i18n="@@fetchedFromTruecaller">Fetched from Truecaller</span>
    </p>
  }
  @if (hasError()) {
    <app-onboarding-profile-field-error id="nameError">
      @if (errorMessage() === GenderFormErrorMessages.numberInName) {
        <span i18n="@@nameErrorSpecialCharactersV2">Enter only letters in your name. Do not use numbers or special characters (like &#64;, #, /, ,).</span>
      }
      @if (errorMessage() === GenderFormErrorMessages.emptyName) {
        <span i18n="@@nameErrorEmptyNameV2">Enter your name to continue</span>
      }
      @if (errorMessage() === GenderFormErrorMessages.maxNameLength) {
        <span i18n="@@nameErrorLengthLimitV2">Please enter only up to 3 words in your name</span>
      }
    </app-onboarding-profile-field-error>
  }

  <button shellFooter
    csButton
    id="continueBtn"
    type="button"
    class="tw-w-full"
    [loading]="loading()"
    (click)="handleContinue()"><span i18n="@@continueNew">Continue</span>
  </button>
</app-onboarding-profile-shell>
